<template>
  <div class="container">
    <div class="conditions_box">
      <img src="@/assets/archedShape2.png" class="img-fluid gonbad"/>

      <div class="row">

        <div class="col-12 col-md-8 mx-auto">
          <div class="content-wrapper">
            <h1>ثبت نام اولیه سامانه پلیس امنیت</h1>
            <div class="card content-box">
              <div class="card-body">
                <p class="text-justify intro-text">
                  <span>سامانه برخط ناظر یک، یک نرم افزار موبایلی می باشد</span><br>
                  <span>دسترسی به این نرم افزار فقط برای کسانی که پلیس امنیت عمومی نیروی انتظامی جمهوری اسلامی ، آنها را تایید کرده باشند و امکان </span><br>
                  <span>ورود به نرم افزار را فعال نموده باشد، امکان پذیر می باشد</span><br>
                  <span>در این نرم افزار پس از اینکه فردِ دارای دسترسی، شماره پلاک ماشینی که در آن کشف حجاب شده ( تاریخ و ساعت و مکان) را </span><br>
                  <span>وارد و  ثبت میکند، در عرض چند ثانیه پیامک اخطار به صاحب ماشین ارسال میگردد.</span><br>
                </p>
                <RouterLink to="/intro" class="bbot mx-auto">
                  ▶ صفحه قبل
                </RouterLink>
                <RouterLink to="/introThird" class="bbot mx-auto">
                  صفحه بعد ◀
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.intro-text{
  font-family: Calibri,sans-serif;
}
</style>
<script>
/*import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  }
}*/

</script>
